"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_web_components_1 = require("@nimles/react-web-components");

var react_redux_1 = require("react-redux");

var Link_1 = require("./Link");

var toTree = function toTree(productGroups, parent) {
  return productGroups.filter(function (pg) {
    return parent ? pg.parentId === parent.id : !pg.parentId;
  }).map(function (pg) {
    return __assign(__assign({}, pg), {
      children: toTree(productGroups, pg)
    });
  });
};

var ProductGroup = function ProductGroup(_a) {
  var productGroup = _a.productGroup;
  return react_1.default.createElement(react_web_components_1.ListItem, {
    key: productGroup.id
  }, react_1.default.createElement(Link_1.NavLink, {
    to: "/" + productGroup.uniqueName
  }, productGroup.name), react_1.default.createElement(react_web_components_1.List, null, productGroup.children.map(function (productGroup) {
    return react_1.default.createElement(ProductGroup, {
      productGroup: productGroup
    });
  })));
};

exports.ProductGroupList = function () {
  var productGroups = react_redux_1.useSelector(function (_a) {
    var publicProductGroups = _a.publicProductGroups;
    return publicProductGroups.values;
  });
  var productGroupTree = toTree(productGroups);
  return react_1.default.createElement(react_web_components_1.List, null, productGroupTree.map(function (productGroup) {
    return react_1.default.createElement(ProductGroup, {
      productGroup: productGroup
    });
  }));
};